import React, { useEffect, useState,useRef,useContext} from 'react';
import $ from 'jquery';
import axios from 'axios';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import CreatePassword from './css/show-password';
import Select from 'react-select';
import qs from 'qs';
import RefreshContext from './RefreshContext';
function Notification() {
  const { refreshKey } = useContext(RefreshContext);

  const [staff, setStaff] = useState([]);
  const [app, setApp] = useState([]);
  const passwordVisibility = CreatePassword('password');
  const passwordVisibility2 = CreatePassword('confirm');
  const [changes, setChanges] = useState({});
  const [userss,setUsername] = useState("");
  const [searchText, setSearchText] = useState("");
  const searchRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sid,setUserID] = useState(0);
  const [selectedpost,setPost] = useState(null);

  const [selectedPost, setSelectedPost] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [statusData, setStatusData] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]); // for API


  const fetchData = async () => {
    const response = await axios.get(apiurl + 'notification.php?subdomain=react'); // Replace with your API endpoint
    setStaff(response.data.notification || []);
  };

 
  // Debounce function
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  useEffect(() => {
    document.title = "Staff | MERAQUI";
    fetchData();
    $('#modalclose').on('click', function () {
      $("#hidden").val("");
      $("#reset").click();
      setPost(null);
    });


    $('.appCloseModal').on('click', function () {
      setApp([]);
      setUserID("");
    });


    searchRef.current = debounce((value) => {
      setLoading(true);

      setTimeout(() => {
        const items = document.querySelectorAll(".staff-card"); // <-- wrap each staff in this class
        let found = false;

        items.forEach((item) => {
          const text = Array.from(
            item.querySelectorAll(".search-value") // search in all elements with search-value
          )
            .map((el) => el.textContent?.toLowerCase() || "")
            .join(" ");

          const match = text.includes(value);
          item.style.display = match ? "block" : "none";
          if (match) found = true;
        });

        document.getElementById("noDataMessage").style.display = found
          ? "none"
          : "block";

        setLoading(false);
      }, 300);
    }, 300);

  }, [refreshKey]);

  const handleChange = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setSearchText(value);
    searchRef.current(value);
  };

 
  return (
    <>
    
      <div className="main-content app-content">

        <div className="container-fluid">
          <div className="row">
 

<div style={{ textAlign: 'center' }}>
  {loading && (
    <div id="searchLoader" className="lds-ellipsis" style={{ color: '#333' }}>
      <div></div><div></div><div></div><div></div>
    </div>
  )}
</div> 

<div id="noDataMessage" style={{ textAlign: 'center', marginTop: '1rem', display: 'none' }}>
  <p className="text-muted">No records found</p>
</div>

 <div class="container-lg" style={{marginTop:'20px'}}>
                      <div class="row justify-content-center">
                            <div class="col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <ul class="list-unstyled mb-0 notification-container">
                                    

 {staff.map((pro, index) => (
  <li key={index}>
      <div class="card custom-card un-read">
              <div class="card-body p-3">
                 <a href="javascript:void(0);">
                                                    <div class="d-flex align-items-top mt-0 flex-wrap">
                                                        <div class="flex-fill">
                                                            <div class="d-flex align-items-center">
                                                                <div class="mt-sm-0 mt-2">
                                                                    <p class="mb-0 fs-14 fw-semibold">{pro.title}</p>
                                                                    <p class="mb-0 text-muted">{pro.message}</p>
                                                                </div>
                                                                 <div class="ms-auto">
                                                                    <span class="float-end badge bg-light text-muted">
                                                                        {pro.dates}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>    
              </div>
        </div>
    </li>
    
 ))}
</ul>
</div>
</div>
</div>

       </div>
        </div>
      </div>

    </>
  );
};
export default Notification;